import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Typography from '../../../../../components/Typography';
import { i18nNS } from '../../../../../i18n';
import InnerLayout from '../InnerLayout';
import useAttendanceRecorded from './vm';
import { RetakeAttendanceButton } from './styles';

const AttendanceRecorded = () => {
  const { t } = useTranslation([i18nNS.CLASS]);
  const { numOfAttempts, numOfPresentStudents, handleOnClickRetakeAttendance } = useAttendanceRecorded();

  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <InnerLayout>
        <Stack gap={4} height="100%">
          <Stack flex={1} justifyContent="center" alignItems="center" gap={6} p={3}>
            <Typography variant="h6Bold" color="error.500" textTransform="uppercase">
              {t('attendance_summary', { ns: i18nNS.CLASS })}
            </Typography>
            <Stack alignItems="center" gap={1}>
              <Typography variant="paragraphMedium">{numOfAttempts}</Typography>
              <Typography variant="paragraphMedium">
                {t('number_of_attempts', { ns: i18nNS.CLASS })}
              </Typography>
            </Stack>
            <Stack alignItems="center" gap={1}>
              <Typography variant="paragraphMedium">{numOfPresentStudents}</Typography>
              <Typography variant="paragraphMedium">
                {t('students_marked_present', { ns: i18nNS.CLASS })}
              </Typography>
            </Stack>
          </Stack>
          <RetakeAttendanceButton size="large" onClick={handleOnClickRetakeAttendance} fullWidth>
            {t('retake_attendance', { ns: i18nNS.CLASS })}
          </RetakeAttendanceButton>
        </Stack>
      </InnerLayout>
    </Stack>
  );
};

export default AttendanceRecorded;
